import { render, staticRenderFns } from "./page-template.vue?vue&type=template&id=90669364&"
import script from "./page-template.vue?vue&type=script&lang=ts&"
export * from "./page-template.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports